import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledScreenshot = styled('div')(
  () => css`
    .screenshot-image {
      position: relative;
      .img {
        transform: filter(5%);
        border-radius: 4px;
      }

      .icon {
        position: absolute;
        background-color: white;
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        top: 10px;
        left: 0px;
        z-index: 1;
        background: #ffffff;
        border: 1px solid #eeeeee;
        box-sizing: border-box;
        border-radius: 6px;
      }
    }
  `
);

export const StyledScreenshotPortal = styled('div')(
  () => css`
    position: fixed;
    inset: 0;
    z-index: 1300;
    cursor: crosshair;
    display: flex;
    justify-content: center;
    .blur-layout {
      position: absolute;
      inset: 0;
      content: '';
      background-color: black;
      opacity: 0.2;
      z-index: 998;
    }
    .user-selected-section {
      opacity: 0.1;
    }
    .save-section {
      background-color: white;
      padding: 8px 20px;
      position: absolute;
      bottom: 35px;
      z-index: 999;
      opacity: 1;
      cursor: default;
      white-space: nowrap;
      border-radius: 8px;
      direction: rtl;
    }
    .full-screen-img {
      position: fixed;
      inset: 0;
      z-index: 990;
      width: 100%;
      height: 100%;
      transition: all 0.5s;
      left: 0;
      bottom: 0;
      &.close {
        width: 296px;
        height: 144px;
        inset: unset;
        opacity: 0;
        left: 180px;
        top: 200px;
      }
    }
  `
);
